<template>
  <v-container>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-alert
              :show="segundosMensajeActualizacion"
              dismissible
              :variant="mensaje.variant"
              @dismissed="segundosMensajeActualizacion = 0"
              @dismiss-count-down="actualizarSegundosMensajeActualizacion"
            >
              {{ mensaje.texto }}
            </b-alert>
            <div class="d-flex">
              <div class="card-title col-auto me-auto">Modulo de Permisos</div>
              <button
                v-if="rolModuloPermiso.escritura"
                class="btn btn-primary col-auto"
                @click="abrirModalNuevo"
              >
                <i class="mdi mdi-plus me-1"></i>
                Nuevo
              </button>
            </div>
            <div class="d-flex"></div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables tabla-personalizada"
                :items="moduloPermisos"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                select-mode="single"
                selectable
                @filtered="onFiltered"
                :busy="moduloPermisosCargando"
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(activo)="data">
                  <span
                    :class="color(data.item.activo)"
                    class="badge font-size-13"
                    >{{ data.item.activo == 1 ? "Si" : "No" }}</span
                  >
                </template>
                <template #cell(modulo_permiso_id)="data">
                  <span class="font-size-13">{{
                    data.item.modulo_permiso_id.substring(
                      data.item.modulo_permiso_id.length - 4,
                      data.item.modulo_permiso_id.length
                    )
                  }}</span>
                </template>
                <template
                  #cell(accion)="data"
                  v-if="rolModuloPermiso.escritura"
                >
                  <i
                    class="bx bx-edit h3 text-primary pointer me-2"
                    @click="abrirModalEditar(data.item)"
                  ></i>
                  <i
                    class="bx bx-trash h3 text-primary pointer"
                    @click="eliminarModuloPermisoLocal(data.item)"
                  ></i>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="mostrarModal"
      title="Agregar Modulo de Permiso"
      hide-footer
      size="md"
    >
      <loading-flux :value="loading"></loading-flux>
      <form @submit.prevent="submit">
        <div class="row">
          <div class="col-lg-6">
            <div class="mb-3">
              <label for="nombreModuloPermiso"
                >Nombre del Modulo de Permiso</label
              >
              <input
                id="nombreModuloPermiso"
                v-model="$v.form.nombreModuloPermiso.$model"
                type="text"
                class="form-control"
                placeholder="Nombre Modulo Permiso"
                :class="{
                  'is-invalid': submitted && $v.form.nombreModuloPermiso.$error,
                }"
              />
              <div
                v-if="submitted && !$v.form.nombreModuloPermiso.required"
                class="invalid-feedback"
              >
                El campo es obligatorio.
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="mb-3">
              <label for="activo">Activo</label>
              <div class="form-check form-switch form-switch-lg mb-3">
                <input
                  v-model="$v.form.activo.$model"
                  class="form-check-input"
                  type="checkbox"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-end mt-3">
          <b-button variant="light" @click="mostrarModal = false"
            >Cerrar</b-button
          >
          <b-button
            v-if="rolModuloPermiso.escritura"
            type="submit"
            variant="success"
            class="ms-1"
            >Guardar</b-button
          >
        </div>
      </form>
    </b-modal>
  </v-container>
</template>
<script>
// import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { moduloPermisoMethods, moduloPermisoComputed } from "@/state/helpers";
import Swal from "sweetalert2";
import { authMethods, authUsuarioComputed } from "@/state/helpers";
import { permiso } from "@/helpers/authservice/obtener-permisos";
import moment from "moment";
moment.locale("es");
export default {
  mixins: [validationMixin],
  page: {
    title: "Modulo de Permisos",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // Layout,
    PageHeader,
  },

  data() {
    return {
      loading: false,
      mensaje: { variant: "", texto: "" },
      segundos: 5,
      segundosMensajeActualizacion: 0,
      title: "Modulo de Permisos",
      items: [
        {
          text: "Usuarios",
        },
        {
          text: "Modulo de Permisos",
          active: true,
        },
      ],
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "nombre_modulo_permiso",
      sortDesc: false,
      fields: [
        {
          key: "Accion",
          sortable: false,
        },
        {
          key: "modulo_permiso_id",
          label: "Modulo de Permiso Id",
          sortable: true,
        },
        {
          key: "nombre_modulo_permiso",
          label: "Nombre Modulo de Permiso",
          sortable: true,
        },
        {
          key: "activo",
          sortable: true,
        },
      ],
      moduloPermisoSeleccionado: {},
      esEditar: false,
      submitted: false,
      mostrarModal: false,
      moduloPermisos: [],
      moduloPermisosCargando: false,
      form: {
        nombreModuloPermiso: null,
        activo: null,
      },
      rolModuloPermiso: {},
    };
  },
  validations: {
    form: {
      nombreModuloPermiso: { required },
      activo: {},
    },
  },
  mounted() {
    this.obtenerModuloPermisosLocal();
    let permisos = permiso.obtenerPermisos(
      this.user,
      this.$router.currentRoute.name
    );
    this.rolModuloPermiso = permisos;
  },
  methods: {
    ...moduloPermisoMethods,
    actualizarSegundosMensajeActualizacion(segundosMensajeActualizacion) {
      this.segundosMensajeActualizacion = segundosMensajeActualizacion;
    },
    abrirModalNuevo() {
      this.resetForm();
      this.esEditar = false;
      this.submitted = false;
      this.mostrarModal = true;
    },
    abrirModalEditar(datos) {
      this.moduloPermisoSeleccionado = datos;
      this.resetForm();

      this.$v.form.nombreModuloPermiso.$model = datos.nombre_modulo_permiso;
      this.$v.form.activo.$model = datos.activo;

      this.esEditar = true;
      this.submitted = false;
      this.mostrarModal = true;
    },

    obtenerModuloPermisosLocal() {
      this.moduloPermisosCargando = true;
      this.obtenerModuloPermisos()
        .then((res) => {
          this.moduloPermisos = res.body;
          this.totalRows = this.moduloPermisos.length;
          this.moduloPermisosCargando = false;
        })
        .catch((error) => {
          this.moduloPermisosCargando = false;
        });
    },

    submit(e) {
      this.loading = true;
      this.submitted = true;
      this.$v.form.$touch();

      if (this.$v.form.$invalid) {
        this.loading = false;
        return;
      }

      let modulo_permiso_id = "";
      if (this.esEditar) {
        modulo_permiso_id = this.moduloPermisoSeleccionado.modulo_permiso_id;
      }

      const nombre_modulo_permiso = this.$v.form.nombreModuloPermiso.$model;
      const activo = this.$v.form.activo.$model;

      let nuevoModuloPermiso = {
        modulo_permiso_id,
        nombre_modulo_permiso,
        activo,
      };

      if (this.esEditar) {
        this.actualizarModuloPermiso(nuevoModuloPermiso)
          .then((res) => {
            if (res.status == 202) {
              this.mensaje.variant = "danger";
              this.mensaje.texto = "Ha ocurrido un error, intente nuevamente";
            }

            if (res.status == 204) {
              this.mensaje.variant = "success";
              this.mensaje.texto =
                "Modulo Permiso actualizado correctamente!!!";
              this.mostrarModal = false;
            }

            this.segundosMensajeActualizacion = this.segundos;
            this.obtenerModuloPermisosLocal();
            this.loading = false;
          })
          .catch((error) => {
            this.mensaje.variant = "danger";
            this.mensaje.texto = "Ha ocurrido un error, intente nuevamente";
            this.mostrarModal = false;
            this.segundosMensajeActualizacion = this.segundos;
            this.loading = false;
          });
      } else {
        this.crearModuloPermiso(nuevoModuloPermiso)
          .then((res) => {
            if (res.status == 201) {
              this.mensaje.variant = "success";
              this.mensaje.texto = "Modulo Permiso creado correctamente!!!";
              this.mostrarModal = false;
            }

            if (res.status == 208) {
              this.mensaje.variant = "danger";
              this.mensaje.texto = "El Modulo Permiso ya existe!!!";
            }

            this.segundosMensajeActualizacion = this.segundos;
            this.obtenerModuloPermisosLocal();
            this.loading = false;
          })
          .catch((error) => {
            this.mensaje.variant = "danger";
            this.mensaje.texto = "Ha ocurrido un error, intente nuevamente";

            this.segundosMensajeActualizacion = this.segundos;
            this.loading = false;
          });
      }

      this.submitted = false;
    },
    resetForm() {
      this.form = {
        nombreModuloPermiso: null,
        activo: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    eliminarModuloPermisoLocal(item) {
      const mensajeEliminar = Swal.mixin({
        customClass: {
          title: "font-size-18",
          confirmButton: "btn btn-danger ms-2",
          cancelButton: "btn btn-gris-claro",
        },
        buttonsStyling: false,
      });
      mensajeEliminar
        .fire({
          title: "Esta seguro que desea eliminar el registro?",
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          allowOutsideClick: false,
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.eliminarModuloPermiso(item.modulo_permiso_id)
              .then((res) => {
                if (res.status == 202) {
                  this.mensaje.variant = "danger";
                  this.mensaje.texto =
                    "Ha ocurrido un error, intente nuevamente";
                }

                if (res.status == 204) {
                  this.mensaje.variant = "success";
                  this.mensaje.texto =
                    "Modulo Permiso eliminado correctamente!!!";
                  this.mostrarModal = false;
                }
                this.segundosMensajeActualizacion = this.segundos;
                this.obtenerModuloPermisosLocal();
              })
              .catch((error) => {
                this.mensaje.variant = "danger";
                this.mensaje.texto =
                  "No se ha eliminado el registro, intente nuevamente";
                this.mostrarModal = false;
                this.segundosMensajeActualizacion = this.segundos;
              });
          }
        });
    },
    color(item) {
      if (item == 1) {
        return "badge-soft-success";
      } else {
        return "badge-soft-warning";
      }
    },
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
  },
  computed: {
    ...authUsuarioComputed,
    // ...moduloPermisoComputed,
    rows() {
      return 1;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },
};
</script>
